import Helper from './Helper';

class Sharing {
  constructor(config = {}) {
    const {
      sharingClass,
      buttonClass
    } = config

    this.sharingClass = sharingClass;
    this.sharingContainer = document.querySelector(this.sharingClass);

    this.buttonClass = buttonClass;
    this.buttons = Array.prototype.slice.call(document.querySelectorAll(buttonClass));

    this.bindEvents();
  }

  bindEvents() {
    this.buttons.forEach(el => {
      el.addEventListener('click', (e) => {
        Helper.toggleClass(this.sharingContainer, 'active');
      } );
    });
  }
}

export default Sharing;
